import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../../Models/GameModel";
import {AnimationContents} from "../../AnimationContents";
import {GameLogic} from "../../../Logic/GameLogic";
import { FieldTypeConstants } from "../../../Constants/FieldTypeConstants";
import {ButtonController, IButtonControllerOptions} from "../../Common/ButtonController";

export interface IIntroScreenControllerOptions
{
}

export class MapSizeController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options:IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("MapSizeController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
                LVL_1_Button: {
                    instanceName: "map_3x3",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this.gotoAndStop(0);
                            this._setFieldSize(FieldTypeConstants.Small);
                        }
                    }
                },
                LVL_2_Button: {
                    instanceName: "map_4x4",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this.gotoAndStop(1);
                            this._setFieldSize(FieldTypeConstants.Medium);
                        }
                    }
                },
                LVL_3_Button: {
                    instanceName: "map_5x5",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this.gotoAndStop(2);
                            this._setFieldSize(FieldTypeConstants.Big);
                        }
                    }
                },
            },
            modelWatch: {
                
            }
        };
    }

    private _setFieldSize(type: FieldTypeConstants) {
        this._gameLogic.setFieldType(type);
    }

    protected onInitialize(): void {
        this.gotoAndStop(0);
        this._setFieldSize(FieldTypeConstants.Small)
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

